import EquipmentTablet from './EquipmentTablet';

export default EquipmentTablet;
export { EquipmentTablet };
